var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.67 36.8"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.67 4.63A4.63 4.63 0 0053 0H4.63A4.63 4.63 0 000 4.63L28.83 23.2zM0 7.56v24.6a4.63 4.63 0 004.63 4.64H53a4.63 4.63 0 004.63-4.64V8.46l-28.83 18z",
    fill: "#999",
    "data-name": "Layer 1"
  }))));
}
export default SvgEmail;